module.exports = __webpack_public_path__ + "img/25.d35bbe72.svg";